import { Controller } from "@hotwired/stimulus"
import $ from "jquery";

export default class extends Controller {
  connect() {
    this.setUpDatePickers();
  }

  setUpDatePickers() {
    // Helper to check if end date is in the past
    function isEndDatePast(date) {
      if (!date) return false;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      // If date is today or before today, return true
      return date <= today;
    }

    // Helper to show/hide error and disable/enable submit
    function updateEndDateError() {
      const $endDate = $('.js-datepicker-end');
      const $submit = $('.course-btn__submit');
      const $error = $('#end-date-error');
      const endDate = $endDate.datepicker('getDate');

      if (isEndDatePast(endDate)) {
        $error.show();
        $submit.prop('disabled', true);
        $submit.addClass('disabled').css('opacity', 0.5);
      } else {
        $error.hide();
        $submit.prop('disabled', false);
        $submit.removeClass('disabled').css('opacity', '');
      }
    }

    const togglePlaceholder = ($input) => {
      const $wrapper = $input.closest('.course-dates__input-wrapper');
      const $placeholder = $wrapper.find('.course-dates__placeholder');
      if ($input.val()) {
        $placeholder.hide();
      } else {
        $placeholder.show();
      }
    }

    const parseDate = (val) => {
      try {
        return $.datepicker.parseDate("M d, yy", val.replace(/\s+/g, ' ').trim());
      } catch {
        return null;
      }
    };

    const today = new Date();
    const $startDate = $('.js-datepicker-start');
    const $endDate = $('.js-datepicker-end');
    const selectedStartDate = parseDate($startDate.val());
    const selectedEndDate = parseDate($endDate.val());

    // Helper to allow only today or future, except allow preselected past date
    function getBeforeShowDay(selectedDate) {
      return function(date) {
        const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        const dateMidnight = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        if (selectedDate && dateMidnight.getTime() === selectedDate.getTime()) {
          return [true, '']; // allow preselected past date
        }
        if (dateMidnight < todayMidnight) {
          return [false, '']; // disable all other past dates
        }
        return [true, '']; // allow today and future
      };
    }

    $('.js-datepicker-start').datepicker({
      dateFormat: "M d, yy",
      onSelect: function() {
        const start = $(this).datepicker("getDate");
        $endDate.datepicker("option", "minDate", start);
        togglePlaceholder($(this));
        const event = new CustomEvent("datepicker:changed", { bubbles: true });
        this.dispatchEvent(event);
        updateEndDateError();
      }
    });

    $('.js-datepicker-end').datepicker({
      dateFormat: "M d, yy",
      minDate: selectedStartDate,
      onSelect: function() {
        const end = $(this).datepicker("getDate");
        $startDate.datepicker("option", "maxDate", end);
        togglePlaceholder($(this));
        const event = new CustomEvent("datepicker:changed", { bubbles: true });
        this.dispatchEvent(event);
        updateEndDateError();
      }
    });

    togglePlaceholder($startDate);
    togglePlaceholder($endDate);
    // On load, check end date
    updateEndDateError();
  }
}
